import { MedicationStatement } from '@medplum/fhirtypes';
import { FC } from 'react';
import { getDisplayString } from '@medplum/core';
import { ResourceListSection } from '../shared/ResourceListSection';
import { ResourceListSectionConfig } from '../shared/ResourceListSectionConfig';
import { MedicationListItem } from '../../../examination/medications/MedicationListItem';
import { getMedicationName } from '@/utils/medication.utils';
import { createActiveFilter } from '../shared/resource-sort-utils';

// -----------------------------------------------------------------------------
export interface MedicationsProps {
  readonly medications: MedicationStatement[];
}

// -----------------------------------------------------------------------------
const medicationConfig: ResourceListSectionConfig<MedicationStatement> = {
  titleKey: 'summaryPage.summary.medications.title',
  noneKey: 'summaryPage.summary.medications.none',
  noResourcesKey: 'summaryPage.summary.medications.none',

  sortResources: createActiveFilter<MedicationStatement>((med) => med.status),
  getDisplayDate: (medication) =>
    medication.effectivePeriod?.start || medication.dateAsserted || '',

  getDisplayName: (medication) =>
    getMedicationName(medication) || getDisplayString(medication),

  getStatusLabel: (medication, t) =>
    t(`medications.statusOptions.${medication.status}`, {
      defaultValue: medication.status,
    }),

  renderItem: (medication) => (
    <MedicationListItem medication={medication} readonly />
  ),
};

// -----------------------------------------------------------------------------
export const Medications: FC<MedicationsProps> = ({ medications }) => {
  return (
    <ResourceListSection<MedicationStatement>
      resources={medications}
      config={medicationConfig}
    />
  );
};
